import types from '../constants/actionTypes';

export function viewInfluencer(id) {
  return {
    type: types.influencers.REQUEST_VIEW_INFLUENCER,
    influencerId: id,
  };
};

export function cancelViewInfluencer(id) {
  return {
    type: types.influencers.CANCEL_VIEW_INFLUENCER,
    influencerId: id,
  };
};

export function requestImport() {
  return {
    type: types.influencers.REQUEST_IMPORT,
  };
}

export function requestImportError(response) {
  return {
    type: types.influencers.REQUEST_IMPORT_ERROR,
    error: true,
    payload: {
      statusText: response.error,
      response: { error: response.exception },
    },
  };
}

export function resetInfluencerReportButton() {
  return {
    type: types.influencers.RESET_REPORT_BUTTON,
  };
}



/** WEBPACK FOOTER **
 ** ./actions/influencers.js
 **/